import React, { useState } from "react";
import ErrorPage from "../ErrorPage";
import ForbiddenIcon from "../ForbiddenIcon";
import HyroButton from "@hyro-components/hyro-button/HyroButton";
import { BUTTON_VARIANTS, BUTTON_SIZES } from "@hyro-components/hyro-button/HyroButton.consts";
import LockIcon from "src/icons/LockIcon";
import { LINKS } from "@consts";
import RequestAccessDialog from "./components/request-access-dialog/RequestAccessDialog";
import useAppStore from "src/stores/appStore";
import { userDataSelector } from "src/stores/selectors/appSelectors";
import { isHyroUser } from "src/utils/core/utils";
import { useFlags } from "launchdarkly-react-client-sdk";

const ForbiddenErrorPage = ({ showRequestAccess = true }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const userData = useAppStore(userDataSelector);
  const { enableAutomatedPermissions } = useFlags();
  const showRequestAccessButton = showRequestAccess && isHyroUser(userData) && enableAutomatedPermissions;

  const pageLinks = [
    { url: "/", text: "Go to home page" },
    { url: LINKS.HYRO_SUPPORT, text: "Contact support" }
  ];

  const handleRequestAccess = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <ErrorPage
        code="403"
        message="Forbidden"
        explanation="You don't have access to this page"
        links={pageLinks}
        Icon={ForbiddenIcon}
        actionButton={
          showRequestAccessButton ? <HyroButton
            sx={{ mt: 3 }}
            variant={BUTTON_VARIANTS.OUTLINED}
            size={BUTTON_SIZES.SMALL}
            onClick={handleRequestAccess}
            startIcon={<LockIcon />}
          >
            Request access
          </HyroButton>
            : null
        }
      />
      {showRequestAccessButton && <RequestAccessDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
      />
      }
    </>
  );
};

export default ForbiddenErrorPage;

